import{t as r}from"./toString-363ab2b0.js";var t=0;var a=function(a){var o=++t;return r(a)+o};export{a as u};
//# sourceMappingURL=uniqueId-bc45903f.js.map
